// Admin dashboard guard rails (Round 2, AUDIT PR).
// PR E put Submit and Regenerate on one shared scoring code, so no form needs a warning now. The list stays
// so a form can be added back here if Regenerate ever needs a warning again.
export const RISKY_REGEN = {};

export function regenWarning(assessmentType) {
  return RISKY_REGEN[assessmentType] || "";
}

export function regenConfirmText(assessmentType) {
  const w = regenWarning(assessmentType);
  const base = `This will regenerate the PDF for this ${assessmentType} assessment.`;
  return w ? `DON'T REGENERATE YET\n\n${w}\nThis is fixed in the next scoring update.\n\n${base} Continue anyway?` : `${base} Continue?`;
}

export function regenAllConfirmText(clientName, assessments) {
  const risky = [...new Set((assessments || []).filter((a) => a.status !== "draft" && RISKY_REGEN[a.assessment_type]).map((a) => a.assessment_type))];
  const base = `This will regenerate ALL PDFs for "${clientName}". This may take a moment.`;
  if (!risky.length) return `${base} Continue?`;
  return `DON'T REGENERATE YET\n\nThis client has ${risky.join(", ")}, which Regenerate still gets wrong:\n${risky.map((t) => `- ${t}: ${RISKY_REGEN[t]}`).join("\n")}\nThis is fixed in the next scoring update.\n\n${base} Continue anyway?`;
}

// A finished assessment whose PDF was never made (the PDF step failed on submit).
export function hasNoPdf(a) {
  return !!a && a.status !== "draft" && !a.pdf_path;
}
